import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  //   .defaultText {
  //     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
  //       Ubuntu, Cantarell, sans-serif;
  //   }
  .headerTagsCard {
    padding: 1.5rem;
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
      rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  }
  @media (max-width: 768px) {
    .headerTagsCard {
      padding: 0.5rem !important;
    }
    .resultCard {
      padding: 0.5rem !important;
    }
    .resultCard .card-body {
      padding: 0.5rem !important;
    }
  }
`;
